<template>
  <PageWrapper
    :active-section="SECTION_MONETIZATION"
    :active-page="PAGE_LINKS_REPORT"
    title="My Links"
    page-name="My Links"
    :breadcrumbs="breadcrumbs"
    :action-button-href="`/monetization/org/${orgId}/links/collections`"
    action-button-text="View Collections"
    secondary-button-text="Create A Link"
    @secondary-button-click="openCreateLinkModal"
  >
    <iRow :width="2700">
      <SmartFeed :source="useMyMonetizationLinksFeedStore" default-feed-layout="table" load-more-behavior="auto">
        <template #empty-state>
          <iRow vertical-align="middle" class="empty-state">
            <iIcon icon="hyperlink" size="large" />
            <iText>No Affiliate Links yet.</iText>
          </iRow>
        </template>
      </SmartFeed>
    </iRow>

    <AddAffiliateLinkToCollectionModal />

    <iModal
      :show-footer="false"
      :visible="isCreateLinkModalOpen"
      :max-width="650"
      title="Create Affiliate Link"
      @close="closeCreateLinkModal"
    >
      <template #body>
        <LinkGeneratorWidget />
      </template>
    </iModal>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import { mapState, mapWritableState } from "pinia";
import SmartFeed from "SmartFeed/components/SmartFeedV2";
import { SECTION_MONETIZATION, PAGE_LINKS_REPORT } from "@/constants/nav-constants";
import AddAffiliateLinkToCollectionModal from "@/components/AddAffiliateLinkToCollectionModal.vue";
import LinkGeneratorWidget from "@/components/LinkGeneratorWidget.vue";
import { useMyMonetizationLinksFeedStore } from "@/smart-feed/stores/feed/my-monetization-links-feed-store";

export default {
  name: "LinksReport",
  components: {
    LinkGeneratorWidget,
    AddAffiliateLinkToCollectionModal,
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_MONETIZATION,
      PAGE_LINKS_REPORT,
    };
  },
  computed: {
    ...mapWritableState(useAffiliateLinkStore, [
      "isCreateLinkModalOpen",
    ]),
    ...mapState(useAffiliateLinkStore, [
      "orgId",
      "affiliateLinks",
      "loadingAffiliateLinks",
      "hasMoreAffiliateLinks",
      "createdAffiliateLink",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
      ];
    },
  },
  methods: {
    useMyMonetizationLinksFeedStore,
    closeCreateLinkModal() {
      this.isCreateLinkModalOpen = false;
      if (typeof this.createdAffiliateLink == "object" && Object.keys(this.createdAffiliateLink).length > 0) {
        window.location.reload();
      }
    },
    openCreateLinkModal() {
      this.isCreateLinkModalOpen = true;
    },
  },
};
</script>
